module.exports = __webpack_public_path__ + "static/media/photo84.a1d01d0d.jpg";